// Arabic Testimonials Data
const testimonialsDataArabic = {
  badgeText: 'شهادات العملاء',
  titles: [
    {
      title: 'ماذا يقول',
      highlight: false,
      breakPoint: false,
    },
    {
      title: ' عملاؤنا',
      highlight: true,
      breakPoint: false,
    },
  ],
  description: [
    {
      content: 'استمع إلى عملائنا الراضين حول تجربتهم مع خدمات ',
      highlight: false,
    },
    {
      content: 'سُبُل للمقاولات',
      highlight: true,
    },
    {
      content: ' في مجال التكييف والتهوية. ثقتهم ورضاهم يدفعان التزامنا بالتميز.',
      highlight: false,
    },
  ],
  testimonials: [
    {
      name: 'أحمد الراشد',
      position: 'مدير المرافق، مركز طبي',
      rating: 5,
      review: 'خدمة تكييف استثنائية! الفريق كان محترفاً وفعالاً وقدم بالضبط ما وعد به. مرفقنا الطبي لديه الآن تحكم مثالي في المناخ.',
    },
    {
      name: 'فاطمة الزهراء',
      position: 'مديرة العمليات، مجمع مكاتب',
      rating: 4,
      review: 'شركة سُبُل للمقاولات غيرت بيئة مكتبنا. التركيب كان سلساً وخدمة الصيانة تحافظ على عمل كل شيء بسلاسة.',
    },
    {
      name: 'محمد إبراهيم',
      position: 'مدير المصنع، التصنيع',
      rating: 5,
      review: 'حلول تكييف صناعية متميزة. فهموا متطلباتنا المحددة وقدموا نظاماً حسّن كفاءة عملياتنا بشكل كبير.',
    },
    {
      name: 'أمل المنصوري',
      position: 'صاحبة مطعم',
      rating: 5,
      review: 'نظام تهوية مطبخ مثالي! الفريق كان على دراية بمتطلبات المطاعم وقدم دعماً ممتازاً مستمراً.',
    },
    {
      name: 'عمر الفهد',
      position: 'عميل سكني',
      rating: 4,
      review: 'أفضل خدمة تكييف في المنطقة. تركيب احترافي، أسعار عادلة، وخدمة عملاء ممتازة. أنصح بشدة لأي احتياجات تكييف.',
    },
  ],
};

// Arabic Process Data
const processDataArabic = {
  badgeText: 'عمليتنا',
  titles: [
    {
      title: 'كيف',
      highlight: false,
      breakPoint: false,
    },
    {
      title: ' نعمل',
      highlight: true,
      breakPoint: false,
    },
  ],
  description: [
    {
      content: 'نهجنا المنهجي يضمن ',
      highlight: false,
    },
    {
      content: 'نتائج عالية الجودة',
      highlight: true,
    },
    {
      content: ' ورضا العملاء في كل مشروع تكييف نقوم به.',
      highlight: false,
    },
  ],
  steps: [
    {
      stepNumber: '1',
      icon: 'phone',
      title: 'الاستشارة الأولية',
      description: 'نبدأ بفهم احتياجاتك المحددة للتكييف من خلال استشارة مفصلة وتقييم الموقع.',
    },
    {
      stepNumber: '2',
      icon: 'clipboard',
      title: 'التصميم المخصص',
      description: 'خبراؤنا ينشئون تصميم حل تكييف مخصص يلبي متطلباتك وميزانيتك.',
    },
    {
      stepNumber: '3',
      icon: 'tool',
      title: 'التركيب المهني',
      description: 'فنيونا المعتمدون يضمنون تركيباً دقيقاً مع أقل تعطيل لعملياتك.',
    },
    {
      stepNumber: '4',
      icon: 'check',
      title: 'الاختبار والصيانة',
      description: 'نختبر النظام بدقة ونقدم صيانة مستمرة لضمان الأداء الأمثل.',
    },
  ],
};

// Arabic Why Choose Us Data
const whyChooseUsDataArabic = {
  badgeText: 'لماذا تختارنا',
  titles: [
    {
      title: 'شريكك الموثوق',
      highlight: false,
      breakPoint: false,
    },
    {
      title: ' في التكييف',
      highlight: true,
      breakPoint: false,
    },
  ],
  description: [
    {
      content: 'مع أكثر من ',
      highlight: false,
    },
    {
      content: '12 عاماً من الخبرة',
      highlight: true,
    },
    {
      content: ' في صناعة التكييف، نقدم حلولاً موثوقة وفعالة وفعالة من حيث التكلفة تتجاوز التوقعات.',
      highlight: false,
    },
  ],
  keyPoints: [
    {
      title: 'مهنيون معتمدون',
      description: 'فريقنا يتكون من فنيي تكييف مرخصين ومعتمدين ذوي خبرة واسعة.',
    },
    {
      title: 'خدمة طوارئ 24/7',
      description: 'دعم على مدار الساعة لمشاكل التكييف العاجلة لتقليل وقت التوقف.',
    },
    {
      title: 'ضمان الجودة',
      description: 'نقف وراء عملنا بضمانات شاملة وضمانات الرضا.',
    },
  ],
  features: [
    {
      icon: 'award',
      title: 'خبرة الصناعة',
      description: 'معرفة متخصصة في أنظمة التكييف التجارية والصناعية والسكنية.',
    },
    {
      icon: 'clock',
      title: 'التسليم في الوقت المحدد',
      description: 'ملتزمون بإكمال المشاريع في الموعد المحدد دون المساومة على الجودة.',
    },
    {
      icon: 'dollar-sign',
      title: 'حلول فعالة من حيث التكلفة',
      description: 'أسعار تنافسية مع عروض أسعار شفافة وبدون تكاليف خفية.',
    },
  ],
};

// Arabic Stats Data
const statsDataArabic = {
  badgeText: 'إنجازاتنا',
  titles: [
    {
      title: 'أرقام تتحدث',
      highlight: false,
      breakPoint: false,
    },
    {
      title: ' عن النجاح',
      highlight: true,
      breakPoint: false,
    },
  ],
  description: [
    {
      content: 'أكثر من ',
      highlight: false,
    },
    {
      content: 'عقد من التميز',
      highlight: true,
    },
    {
      content: ' في صناعة التكييف، نخدم العملاء عبر قطاعات مختلفة بتفان وخبرة.',
      highlight: false,
    },
  ],
  stats: [
    {
      icon: 'users',
      value: '500',
      suffix: '+',
      title: 'عملاء سعداء',
      description: 'عملاء راضون عبر قطاعات مختلفة',
    },
    {
      icon: 'briefcase',
      value: '1200',
      suffix: '+',
      title: 'مشاريع مكتملة',
      description: 'تركيبات وصيانة تكييف ناجحة',
    },
    {
      icon: 'calendar',
      value: '12',
      suffix: '+',
      title: 'سنوات خبرة',
      description: 'خبرة راسخة في حلول التكييف',
    },
    {
      icon: 'thumbs-up',
      value: '99',
      suffix: '%',
      title: 'معدل النجاح',
      description: 'رضا العملاء ونجاح المشاريع',
    },
  ],
  achievements: {
    title: 'شهاداتنا وشراكاتنا',
    items: [
      { icon: 'check-circle', title: 'معتمد ISO' },
      { icon: 'shield', title: 'مقاول مرخص' },
      { icon: 'star', title: 'شريك ممتاز' },
      { icon: 'award', title: 'رائد الصناعة' },
      { icon: 'zap', title: 'موفر للطاقة' },
      { icon: 'globe', title: 'صديق للبيئة' },
    ],
  },
};

// Arabic CTA Section Data
const ctaSectionDataArabic = {
  titles: [
    {
      title: 'هل أنت مستعد لتحويل',
      highlight: false,
      breakPoint: false,
    },
    {
      title: ' بيئتك الداخلية؟',
      highlight: true,
      breakPoint: false,
    },
  ],
  description: [
    {
      content: 'احصل على ',
      highlight: false,
    },
    {
      content: 'حلول تكييف متخصصة',
      highlight: true,
    },
    {
      content: ' مصممة لاحتياجاتك. تواصل معنا اليوم للحصول على استشارة وعرض سعر مجاني.',
      highlight: false,
    },
  ],
  primaryButton: {
    text: 'احصل على عرض مجاني',
    link: '/contact-us',
    icon: 'phone',
  },
  secondaryButton: {
    text: 'عرض الخدمات',
    link: '/services',
    icon: 'eye',
  },
};

export { testimonialsDataArabic, processDataArabic, whyChooseUsDataArabic, statsDataArabic, ctaSectionDataArabic };
